import { options as optionsApi } from '@afosto/contacts/api/Options';

const SESSION_STORAGE_SESSION_KEY_LABEL = 'afosto-address-search-session-key';
const SUPPORTED_COUNTRIES = ['NLD', 'BEL', 'DEU', 'LUX', 'AUT', 'CHE'];

const matchesAreSameAddress = matches => {
  if (matches.length < 1) {
    return false;
  }
  const [firstResult] = matches;
  return matches
    .filter(match => match.precision === 'Address')
    .every(address => address?.label?.includes(firstResult?.label));
};

const createSessionKey = async (countryCode, sessionKey) => {
  try {
    const sessionResponse = await optionsApi.startAddressSearchSession({
      countryCode,
      sessionKey,
    });
    const { data } = sessionResponse;

    window.sessionStorage.setItem(SESSION_STORAGE_SESSION_KEY_LABEL, data?.session_key);
    return data?.session_key;
  } catch (e) {
    return null;
  }
};

const getValidatedAddress = async (context, data, query) => {
  try {
    const { countryCode, postalCode, locality, thoroughfare, premiseNumber, premiseNumberSuffix } =
      data ?? {};

    if (!SUPPORTED_COUNTRIES.includes(countryCode?.alpha3Code)) {
      return null;
    }

    let sessionKey = window.sessionStorage.getItem(SESSION_STORAGE_SESSION_KEY_LABEL);
    if (!sessionKey) {
      sessionKey = await createSessionKey(data?.countryCode?.value);
    }

    const queryString = `${postalCode ?? ''} ${locality ?? ''}, ${thoroughfare ?? ''} ${
      premiseNumber ?? ''
    }${premiseNumberSuffix ?? ''}`;

    const searchResponse = await optionsApi.searchAddress({
      session_key: sessionKey,
      context,
      query: queryString,
    });

    const { data: responseData } = searchResponse;
    const { result, options } = responseData ?? {};
    if (result?.address && matchesAreSameAddress(options)) {
      return result;
    }

    return null;
  } catch (error) {
    const { message, code } = error?.response?.data ?? {};
    if (message === 'Could not find session' && code === 403) {
      window.sessionStorage.removeItem(SESSION_STORAGE_SESSION_KEY_LABEL);
      return getValidatedAddress(context, data, query);
    }

    return null;
  }
};

export default getValidatedAddress;
